import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export type SelectionImpressionEventParams = {
	node: Element;
	value: string;
	elementCurrentStep: number;
	elementTotalSteps: number;
	clickID?: boolean;
	element3dStreamAvailable?: boolean;
};

export class SelectionImpressionEvent extends BaseEvent {
	constructor({
		value,
		elementCurrentStep,
		elementTotalSteps,
		element3dStreamAvailable = false,
		clickID = false,
	}: SelectionImpressionEventParams) {
		super({
			eventInfo: {
				eventAction: EventAction.Impression,
				eventName: `selections - selection category impression`,
			},
			attributes: {
				componentName: 'selections',
				value,
				clickID: `${clickID}`,
				relatedElements: [
					{
						elementName: 'selection category',
						elementValue: value,
						elementCurrentStep: `${elementCurrentStep}`,
						elementTotalSteps: `${elementTotalSteps}`,
						element3dStreamAvailable: `${element3dStreamAvailable}`,
					},
				],
			},
		});
	}
}
